import { useQuery } from "@tanstack/react-query";

import { listInvites } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { PendingInvite } from "../types";
import { toPendingInvite } from "../utils/map";

export function useInvites() {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["invites", "pending", activeCanteiroId],
		enabled: activeCanteiroId != null,
		queryFn: async (): Promise<PendingInvite[]> => {
			const { items } = await listInvites({ status: "pending" });
			return items
				.map(toPendingInvite)
				.filter(
					(invite) =>
						invite.worksiteId == null || invite.worksiteId === activeCanteiroId,
				);
		},
		staleTime: 30_000,
	});
}
